import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "modal-wrapper scroll-wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "lot-desktop-tabs"
}
const _hoisted_4 = { class: "lot-desktop-tab" }
const _hoisted_5 = {
  key: 0,
  class: "tab-border"
}
const _hoisted_6 = {
  key: 0,
  class: "lot-desktop-tab"
}
const _hoisted_7 = {
  key: 0,
  class: "tab-border"
}
const _hoisted_8 = { class: "lot-details" }
const _hoisted_9 = {
  key: 0,
  class: "blocks-wr"
}
const _hoisted_10 = { class: "block block-lot-details" }
const _hoisted_11 = {
  key: 0,
  class: "title"
}
const _hoisted_12 = {
  key: 1,
  class: "block"
}
const _hoisted_13 = { class: "lot-title-mobile" }
const _hoisted_14 = {
  key: 0,
  class: "lot-reserve-tabs"
}
const _hoisted_15 = {
  key: 2,
  class: "row-wr"
}
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "row-value" }
const _hoisted_18 = { class: "row secondary" }
const _hoisted_19 = { class: "row-value" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "row-value" }
const _hoisted_22 = { class: "row secondary" }
const _hoisted_23 = {
  key: 1,
  class: "row-value"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "row-value" }
const _hoisted_26 = { class: "row secondary" }
const _hoisted_27 = {
  key: 0,
  class: "lot-img"
}
const _hoisted_28 = {
  key: 0,
  class: "lot-img-title"
}
const _hoisted_29 = ["viewBox"]
const _hoisted_30 = ["d"]
const _hoisted_31 = {
  key: 1,
  class: "content-documents"
}
const _hoisted_32 = { class: "controls" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: $setup.getModalClasses(),
    "transition-name": $props.transitionName
  }, {
    content: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["content-block scroll-wrapper", { 'land-options-available': $setup.landOptionsAvailable }])
            }, [
              ($setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["lot-desktop-title", { 'lot-tab-active': $setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeTab($setup.TabsEnum.LOT_DETAILS)))
                      }, "Lot Details", 2),
                      ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                        : _createCommentVNode("", true)
                    ]),
                    ($props.lot.lotId.documents && $props.lot.lotId.documents.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["lot-desktop-title", { 'lot-tab-active': $setup.isActiveTab($setup.TabsEnum.DOCS) }]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab($setup.TabsEnum.DOCS)))
                          }, "Documents", 2),
                          ($setup.isActiveTab($setup.TabsEnum.DOCS))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) || !$setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        ($setup.isDesktop)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Lot Details"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("div", { class: "stage-back-wr" }, [
                                _createElementVNode("button", {
                                  class: "button-with-icon back",
                                  onClick: $setup.close
                                }, "BACK")
                              ]),
                              _createElementVNode("div", _hoisted_13, "Lot " + _toDisplayString($props.lot.lotId.title), 1),
                              (!$setup.isDesktop)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["button", !$setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) ? 'question' : 'default primary']),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab($setup.TabsEnum.LOT_DETAILS)))
                                    }, "Lot details", 2),
                                    ($props.lot.lotId.documents && $props.lot.lotId.documents.length)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: _normalizeClass(["button", !$setup.isActiveTab($setup.TabsEnum.DOCS) ? 'question' : 'default primary']),
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab($setup.TabsEnum.DOCS)))
                                        }, "Docs", 2))
                                      : _createCommentVNode("", true),
                                    ($setup.landOptionsAvailable)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: _normalizeClass(["button home-designs-tab-btn", !$setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS) ? 'question' : 'default primary']),
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab($setup.TabsEnum.HOME_DESIGNS)))
                                        }, [...(_cache[5] || (_cache[5] = [
                                          _createTextVNode("Home designs", -1),
                                          _createElementVNode("button", { class: "button approve" }, "New", -1)
                                        ]))], 2))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])),
                        ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              ($setup.isDesktop)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-label" }, "Stage", -1)),
                                    _createElementVNode("div", _hoisted_17, _toDisplayString($props.lot.stageId.title), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_18, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-label" }, "Frontage", -1)),
                                _createElementVNode("div", _hoisted_19, _toDisplayString($props.lot.lotId.blockWidth ? `${$setup.formatPrice($props.lot.lotId.blockWidth, false)} m` : "Irregular"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row-label" }, "Size", -1)),
                                _createElementVNode("div", _hoisted_21, _toDisplayString($setup.formatPrice($props.lot.lotId.size, false)) + " sqm", 1)
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-label" }, "Price", -1)),
                                ($setup.shouldShowRequestPricing($props.lot))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "row-value highlighted",
                                      onClick: $setup.toContact
                                    }, _toDisplayString($setup.getPriceDisplay($props.lot)), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.getPriceDisplay($props.lot)), 1))
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-label" }, "Est. Registration", -1)),
                                _createElementVNode("div", _hoisted_25, _toDisplayString($setup.formatDate($props.lot.lotId.registrationDate, "MMM YYYY")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-label" }, "Status", -1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["badge", $setup.getLotStatusClass($props.lot.lotId.status)])
                                }, _toDisplayString($props.lot.lotId.status), 3)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            ($setup.isDesktop)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Lot Shape"))
                              : _createCommentVNode("", true),
                            (_openBlock(), _createElementBlock("svg", {
                              class: "item-wr svg-img",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              version: "1.1",
                              viewBox: `0 0 ${$props.lot.size.width} ${$props.lot.size.height}`
                            }, [
                              _createElementVNode("path", {
                                class: "item-path",
                                d: $props.lot.path
                              }, null, 8, _hoisted_30)
                            ], 8, _hoisted_29))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.isActiveTab($setup.TabsEnum.DOCS))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      ($props.lot.lotId.documents && $props.lot.lotId.documents.length)
                        ? (_openBlock(), _createBlock($setup["BuilderLotDocuments"], {
                            key: 0,
                            documents: $props.lot.lotId.documents
                          }, null, 8, ["documents"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ($setup.landOptionsAvailable && $setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS))
                ? (_openBlock(), _createBlock($setup["BuilderGetStartedTab"], {
                    key: 1,
                    buttonDisabled: $setup.props.buttonsDisabled,
                    onOnRequestQuote: $setup.onRequestQuote
                  }, null, 8, ["buttonDisabled"]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                class: _normalizeClass(["button default primary reserve", [{ 'mt-0': $props.lot.lotId.status !== $setup.LotStatus.AVAILABLE }, { disabled: $setup.props.buttonsDisabled }]]),
                onClick: $setup.toContact,
                disabled: $setup.props.buttonsDisabled
              }, "Make enquiry", 10, _hoisted_33)
            ])
          ]))
    ]),
    _: 1
  }, 8, ["isOpen", "classes", "transition-name"]))
}